// @flow

import React from 'react';
import classnames from 'classnames';

// Styles
import styles from '../styles/itemPreviews.scss';

import type { ModalTypes } from '../utils/constants';
import { types } from '../utils/constants';

type ImagePreviewProps = {
    image: string,
    imageClasses: string,
    dataTn?: ?string,
    styleType?: ModalTypes,
};

export const ImagePreview = ({ dataTn, image, imageClasses, styleType }: ImagePreviewProps) => {
    if (types.CATALOG && !image) {
        return null;
    }

    return (
        <div className={imageClasses}>
            <img
                data-tn={dataTn}
                className={classnames(styles.preview, {
                    [styles.catalogImg]: styleType === types.CATALOG,
                })}
                src={image}
            />
        </div>
    );
};

ImagePreview.defaultProps = {
    dataTn: '',
};

type ItemPreviewsProps = {
    itemImages: string[],
    itemTitles: string[],
    styleType?: ModalTypes,
};

type ItemPreviewsState = {
    note?: string,
};

class ItemPreviews extends React.Component<ItemPreviewsProps, ItemPreviewsState> {
    static defaultProps = {
        itemImages: [],
        itemTitles: [],
    };

    constructor(props: ItemPreviewsProps) {
        super(props);

        this.state = {
            note: '',
        };
    }

    render() {
        const itemImagesCount = this.props.itemImages.length;
        const itemImagePreviews = this.props.itemImages.slice(0, 4);
        const previewEls = itemImagePreviews.map(image => {
            const imageClasses = classnames(styles.previewContainer, {
                [styles.multi]: itemImagesCount > 1,
                [styles.catalogImgContainer]: this.props.styleType === types.CATALOG,
            });

            return (
                <ImagePreview
                    key={image}
                    dataTn="share-modal-item-previews"
                    imageClasses={imageClasses}
                    image={image}
                    styleType={this.props.styleType}
                />
            );
        });

        return (
            <div className={styles.itemPreviews}>
                {previewEls}
                {itemImagesCount === 1 ? (
                    <div
                        data-tn="share-modal-title"
                        className={`${styles.name} ${styles.namePreview}`}
                    >
                        {this.props.itemTitles[0]}
                    </div>
                ) : null}
                {itemImagesCount > 4 ? (
                    <div className={styles.previewContainer}>
                        {/* Count of remainder items that do not get previewed */}
                        <div className={styles.preview}>+{itemImagesCount - 4}</div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default ItemPreviews;
